import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ApiKey } from "types/generated";

import { PERSONAL_API_KEY_DETAILS_URL_PARAM } from "../../constants";

type PersonalApiKeysTableNameCellItem = Pick<ApiKey, "id" | "name"> & {
  isViewerKey: boolean;
};

const PersonalApiKeysTableNameCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<PersonalApiKeysTableNameCellItem>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      {apiKey.isViewerKey && (
        <TableCellLink
          href={`/personal-settings/api-keys?${PERSONAL_API_KEY_DETAILS_URL_PARAM}=${encodeURIComponent(apiKey.id)}`}
        >
          {apiKey.name}
        </TableCellLink>
      )}
      {!apiKey.isViewerKey && <TableCellText>{apiKey.name}</TableCellText>}
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableNameCell;
